import { Stack } from '@mui/material';
import { tankWrapperStyle } from 'app/pages/Map/MapTransportWindow/TabPanelCondition/TabPanelConditionStyle';
import React from 'react';

import { AlarmSection } from './components/AlarmSection';
import { CoverSection } from './components/CoverSection';
import { TanksPaper } from './components/TanksPaper';
import { TrailerSection } from './components/TrailerSection';
import { useGuardData } from './hooks/useGuardData';
import { usePermissions } from './hooks/usePermissions';
import { TRANSPORT_TYPES } from './TabPanelCondition.constants';

/**
 * компонент для отображения состояния танков, крышек, прицепа и системы охраны
 *
 * @param {Object} transportSelectedItem - Выбранный транспорт
 * @param {Object} transportConditionSelectedItem - Выбранное состояние транспорта
 * @param {boolean} galileosky_device_type - Тип устройства Galileosky
 * @param {boolean} guardPermission - Разрешение на управление охраной
 * @param {Array} transportConditionItems - Список всех состояний транспорта
 * @param {boolean} sensorPermission - Разрешение на управление сенсорами
 * @param {boolean} relayPermission - Разрешение на управление УЗА реле
 * @param {Function} declOfNum - Функция склонения числительных
 * @param {Function} handleConditionGuardOutClick - Обработчик кликов по кнопкам управления
 * @param {boolean} fuelLevelPermission - Разрешение на просмотр уровня топлива
 * @param {Array} transportSelectedDate - Выбранный диапазон дат [from, to]
 */
const TanksBlock = ({
  transportSelectedItem,
  transportConditionSelectedItem,
  galileosky_device_type,
  guardPermission,
  transportConditionItems,
  sensorPermission,
  relayPermission,
  declOfNum,
  handleConditionGuardOutClick,
  fuelLevelPermission,
  transportSelectedDate,
}) => {
  // Определяем тип устройства и транспорта
  const galileoskyDevice = !!galileosky_device_type;
  const isFuelTank = transportSelectedItem.type_id === TRANSPORT_TYPES.FUEL_TANK;
  const isCrane = transportSelectedItem.type_id === TRANSPORT_TYPES.CRANE;

  // Получаем данные о состоянии охраны (биты guard_out и guard_status)
  const guardData = useGuardData(transportConditionSelectedItem, galileoskyDevice);

  // Определяем, доступны ли кнопки управления (только для последнего состояния; реле — только в текущий день)
  const { guardDisabled, sensorDisabled, relayDisabled } = usePermissions(
    transportConditionSelectedItem,
    transportConditionItems,
    guardPermission,
    sensorPermission,
    relayPermission,
    transportSelectedDate
  );

  return (
    <Stack direction='row' sx={(theme) => tankWrapperStyle(theme, transportSelectedItem, isFuelTank)}>
      {/* Секция с танками/краном */}
      <TanksPaper
        transportItem={transportSelectedItem}
        conditionItem={transportConditionSelectedItem}
        galileoskyDevice={galileoskyDevice}
        isFuelTank={isFuelTank}
        isCrane={isCrane}
        guardData={guardData}
        guardDisabled={guardDisabled}
        declOfNum={declOfNum}
        onGuardClick={handleConditionGuardOutClick}
        config={config}
      />
      {/* Секция с крышками */}
      <CoverSection
        transportItem={transportSelectedItem}
        conditionItem={transportConditionSelectedItem}
        galileoskyDevice={galileoskyDevice}
        guardData={guardData}
        guardDisabled={guardDisabled}
        onGuardClick={handleConditionGuardOutClick}
        config={config}
      />

      {/* Секция с прицепом */}
      <TrailerSection
        transportItem={transportSelectedItem}
        conditionItem={transportConditionSelectedItem}
        galileoskyDevice={galileoskyDevice}
        guardData={guardData}
        sensorDisabled={sensorDisabled}
        fuelLevelPermission={fuelLevelPermission}
        onSensorClick={handleConditionGuardOutClick}
        config={config}
      />

      {/* Секция с тревогой, УЗА и охраной */}
      <AlarmSection
        transportItem={transportSelectedItem}
        conditionItem={transportConditionSelectedItem}
        galileoskyDevice={galileoskyDevice}
        guardData={guardData}
        guardPermission={guardPermission}
        relayPermission={relayPermission}
        relayDisabled={relayDisabled}
        onGuardClick={handleConditionGuardOutClick}
        config={config}
      />
    </Stack>
  );
};

export default TanksBlock;
